<template>
  <el-card class="h-full">
    <el-table
      v-loading="tableLoading"
      :data="treeData"
      :row-key="isLowCodeEnv ? 'id' : 'menuKey'"
      border
      :height="tableHeight"
      default-expand-all
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="name" :label="$t('菜单名称')">
        <template slot-scope="scope"
          ><span :class="{ 'line-through': scope.row.differentType === 3 }">{{
            scope.row.meta.title
          }}</span></template
        >
      </el-table-column>
      <el-table-column prop="address" :label="$t('备注')">
        <template slot-scope="scope">
          <span :class="menuColor(scope.row.differentType)">{{ scope.row.differentDesc }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt-10px text-center">
      <el-button
        type="primary"
        size="small"
        @click="register"
        :disabled="!updateTree"
        :loading="tableLoading"
        >{{ $t(updateTree ? '注册更新' : '菜单无更新') }}</el-button
      >
    </div>
  </el-card>
</template>
<script>
import { MenuApi } from '@wiz-api/eaf-menu-management'
import { pick, isEmpty, cloneDeep, forEach } from 'lodash'

const menuApiService = new MenuApi()

export default {
  name: 'menuRegister',
  data() {
    return {
      tableLoading: true,
      settingMenus: [],
      treeData: [],
      updateTree: false,
      currentModuleKey: '',
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 40px)'
    },
    isLowCodeEnv() {
      return window.__POWERED_BY_QIANKUN__
    },
  },
  watch: {
    treeData: {
      deep: true,
      handler(treeData) {
        this.findUpdateTree(treeData)
      },
      immediate: true,
    },
  },
  methods: {
    menuColor(differentType) {
      let menuColor = 'text-black-500'
      switch (differentType) {
        case 1:
          menuColor = 'text-blue-500'
          break
        case 2:
          menuColor = 'text-green-500'
          break
        case 3:
          menuColor = 'text-red-500'
          break
        default:
          break
      }
      return menuColor
    },
    findUpdateTree(treeData) {
      // 查找菜单树是否有更新
      if (this.updateTree) {
        return
      }
      _.forEach(treeData, (item) => {
        if (item.differentDesc) {
          this.updateTree = true
          return false
        }
        if (!isEmpty(item.children)) {
          this.findUpdateTree(item.children)
        }
      })
    },
    async compareTree() {
      if (this.isLowCodeEnv) {
        const instance = axios.create()
        instance.defaults.baseURL = Wiz.globalSettings.api.endpoints.default
        const token = localStorage.getItem('authorization')
        instance.defaults.headers.common.Authorization = `Bearer ${token}`
        const res = await instance.post(
          '/api/menu/menus/compare-menus-by-tree',
          _.filter(this.settingMenus, (menu) => {
            return !_.isEmpty(menu.children)
          })
        )
        if (res.status === 200 && res.data) {
          this.tableLoading = false
          this.treeData = res.data
        }
        return
      }
      const [err, res] = await menuApiService.compareMenuDifferentByTree({
        body: this.settingMenus,
      })
      this.tableLoading = false
      if (!err) {
        this.treeData = res
      }
    },
    reWriteMenu(currentMenu, preMenu, flag) {
      // 重写路由
      currentMenu.menuKey = preMenu.id
      currentMenu.url = preMenu.path
      console.log(currentMenu, 'currentMenu')
      currentMenu.icon = ''
      currentMenu.meneGroup = ''
      currentMenu.seqNo = 0
      currentMenu.flag = flag
      if (currentMenu.meta.operations) {
        this.reWriteOperations(currentMenu.meta.operations, currentMenu.meta)
      }
      if (!isEmpty(currentMenu.children)) {
        this.recursionHandleMenus(currentMenu.children, flag, currentMenu.url, currentMenu)
      }
    },
    recursionHandleMenus(menus, flag, path, currentMenu) {
      const filterRepeatMenus = [] // 过滤重复的菜单
      // 递归处理菜单
      _.forEach(menus, (menu) => {
        // if (menu.meta.hidden) {
        //   // 子菜单hidden为true的进行过滤
        //   currentMenu.children = filter(currentMenu.children, (childMenu) => {
        //     return childMenu.id !== menu.id
        //   })
        // } else {
        // 拼接父级path
        menu.path = `${path}/${menu.path}`.replaceAll('//', '/')
        this.reWriteMenu(menu, menu, flag)
        delete menu.component
        delete menu.id
        delete menu.path
        // 低代码环境下，叶子节点下没有children,且url不在paths配置名单里，从menus中移除
        if (
          _.isEmpty(menu.children) &&
          this.isLowCodeEnv &&
          !Wiz.globalSettings.dynamicModules.modules[this.currentModuleKey].paths.includes(menu.url)
        ) {
          filterRepeatMenus.push(menu)
        }

        // }
      })
      if (this.isLowCodeEnv) {
        currentMenu.children = _.differenceBy(menus, filterRepeatMenus, 'menuKey')
      }
    },
    reWriteOperations(operations, meta) {
      // 重写operations,传数组给后端
      const metaOperation = []
      _.forIn(operations, (operation) => {
        operation.seqNo = operation.id
        delete operation.id
        metaOperation.push(operation)
      })
      meta.operations = metaOperation
    },
    routesToMenus() {
      // 路由转为后端的菜单数据
      const currentRoutes = cloneDeep(Wiz.dynamicModules.instances)
      const menus = []
      _.forIn(currentRoutes, (module, key) => {
        this.currentModuleKey = key
        // 当前父级路由
        let rootRoutes = module.routes
        if (isEmpty(rootRoutes)) {
          rootRoutes = module.sysRoutes
        }
        forEach(rootRoutes, (currentRoute) => {
          const menu = pick(currentRoute, ['name', 'meta', 'children'])
          if (currentRoute.group) {
            menu.group = currentRoute.group
          }

          menus.push(menu)
          menu.meta.version = module.version
          // 0为运营商模块 1为普通模块
          const flag = module.flag || 1
          this.reWriteMenu(menu, currentRoute, flag)
        })
      })
      return menus
    },
    register() {
      this.$confirm(this.$t('注册更新,请确认是否继续?'), this.$t('提示'), {
        confirmButtonText: this.$t('确定'),
        cancelButtonText: this.$t('取消'),
        type: 'warning',
      }).then(async () => {
        // 更新
        this.tableLoading = true
        const [err, res] = await menuApiService.mergeMenuByTree({
          body: _.filter(this.settingMenus, (menu) => {
            return !_.isEmpty(menu.children)
          }),
        })
        if (!err) {
          this.updateTree = false
          this.compareTree()
          this.$message.success(this.$t('注册更新成功'))
        }
      })
    },
  },
  created() {
    this.settingMenus = this.routesToMenus()
    console.log(this.settingMenus, ' settingsMenus')
    this.compareTree()
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
</style>
